/*
 *
 * ****************************************************************************
 *  * Copyright (C) 2019 Testsigma Technologies Inc.
 *  * All rights reserved.
 *  ****************************************************************************
 *
 */

export enum TestDataType {
  raw = "raw",
  parameter = "parameter",
  runtime = "runtime",
  global = "global",
  random = "random",
  function = "function"
}
